import { useQuery } from '@apollo/client';
import { gql } from '@apollo/client';
import { PlanYear } from '@coverright/data-access/types/medicare';
import { PdpPlanFieldsFragmentDoc, PdpPlanWithTiers } from '..';

export function usePdpPlansByBid(input?: IPlanInput[], clientId?: string) {
  const { data, loading, called, refetch } = useQuery<{
    [name: string]: PdpPlanWithTiers;
  }>(getPlansQuery(input, clientId), {
    skip: !input?.length,
  });

  return {
    loading,
    called,
    refetch,
    plans: data ? Object.values(data).filter((p) => !!p) : [],
  };
}

const getPlansQuery = (plans?: IPlanInput[], clientId?: string) => {
  let query;
  if (plans?.length) {
    query = plans.map(
      (plan, i) => `plan${i}: PdpPlan(${
        clientId ? 'clientId: "' + clientId + '", ' : ''
      }bidId: "${plan.bidId}", zip: "${plan.zip}", countyName: "${
        plan.countyName
      }"${plan.planYear ? ', planYear: ' + plan.planYear : ''}) {
      ...PdpPlanFields
    }
    `
    );
  } else {
    query = `getMyQuoteId`;
  }
  return gql`{${query}}${PdpPlanFieldsFragmentDoc}`;
};

interface IPlanInput {
  zip: string;
  bidId: string;
  countyName: string;
  planYear?: PlanYear;
}
